import axios from "./api";
class RoleService {
  getAll() {
    return axios.get(`/roles`);
  }
  get(id) {
    return axios.get(`/roles/${id}`);
  }
  create(data) {
    return axios.post(`/roles`, data);
  }

  assignRole(user, data) {
    return axios.post(`/users/${user}/assignRole`, data);
  }
  removeRole(user, data) {
    return axios.post(`/users/${user}/removeRole`, data);
  }
  update(id, data) {
    return axios.put(`/roles/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/roles/${id}`);
  }
  restore(id) {
    return axios.post(`/roles_restore/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RoleService();
